import React from "react";
import { makeStyles, useTheme } from "@material-ui/core/styles";
import Grid from "@material-ui/core/Grid";
import Image from "../../../assets";
import CustomText, { getFontSize, getFontWeight } from "../CustomText";
import RowSection from "../RowSection";
import AddRoundedIcon from "@material-ui/icons/AddRounded";
import RemoveRoundedIcon from "@material-ui/icons/RemoveRounded";
import ExpandMoreRoundedIcon from "@material-ui/icons/ExpandMoreRounded";
import ExpandLessRoundedIcon from "@material-ui/icons/ExpandLessRounded";
import CustomIconButton from "../CustomIconButton";
import Color from "../../../utils/Color";
import Collapse from "@material-ui/core/Collapse";
import CommonQuestions from "../../../containers/pages/OnlineRenewal/components/CommonQuestions";
import useMediaQuery from "@material-ui/core/useMediaQuery";

const useStyles = makeStyles((theme) => ({
  root: {
    flexGrow: 1,
    marginBottom: "40px",

  },
  leftContainer: {
    background:
      "transparent linear-gradient(165deg, #FFC20E 0%, #FEE802 66%, #FEEC01 77%, #FDDB07 86%, #F7941E 100%) 0% 0% no-repeat padding-box",
    padding: 20,

    //height:"100%"
  },
  childrenContainer: {
    [theme.breakpoints.down("md")]: {
      minWidth: 400,
      maxWidth: 400,
      marginTop: 40
    },
    [theme.breakpoints.down("sm")]: {
      minWidth: 300,
      maxWidth: 300,
      marginTop: 40
    },
    minWidth: 450,
    maxWidth: 450,
    marginBottom: 50,
    marginTop: 0,
  },
  titleContainer: {
    display: "flex",
    flexDirection: "column",
    justifyContent: "center",
    alignItems: "center",
  },
  titleTextStyle: {
    [theme.breakpoints.only("xs")]: {
      ...getFontSize("xxlarge"),
    },
    ...getFontSize("xxxlarge"),
    ...getFontWeight("800"),
    color: "#2C3034",
    textAlign: "center",
  },
  imageStepStyle: {
    [theme.breakpoints.only("md")]: {
      width: 100,
      height: 100,
    },
    [theme.breakpoints.only("sm")]: {
      width: 70,
      height: 70,
    },
    width: 140,
    height: 140,
  },
  connectorImageContainer: {
    display: "flex",
    flexDirection: "column",
    justifyContent: "center",
    alignItems: "center",
  },
  connectorImageStyle: {
    [theme.breakpoints.only("xs")]: {
      width: 10,
      height: 35,
    },
    [theme.breakpoints.only("sm")]: {
      width: 35,
      height: 10,
    },
    width: 40,
    height: 10,
  },
  stepTextStyle: {
    color: "#2C3034",
    textAlign: "center",
  },
  iconButtonStyle: {
    marginRight: 0,
    padding: 0,
    color: Color.primaryColor,
  },
  TNCContainer: {
    marginTop: 10,
  },
  TNCTextStyle: {
    color: "#2C3034",
  },
  helpContainer: {
    marginTop: 30,
  },
  highLightedTextStyle: {
    color: "#2C3034",
    fontFamily: "Muli",
    ...getFontSize("small"),
    ...getFontWeight("600"),
    textDecoration: "underline",
    "&:hover": {
      cursor: "pointer",
    },
  },
  customerCareImageStyle: {
    width: 40,
    height: 40,
  },
  customerCareTextStyle: {
    color: "#2C3034",
    textAlign: "center",
    lineHeight: 1.4,
  },
  renewNowTextStyle: {
    ...getFontSize("xxxlarge"),
    ...getFontWeight("800"),
    textAlign: "left",
  },
}));

const CustomBoardRenewal = ({ maintenanceChild, children, height, width, maintainMsg }) => {
  const classes = useStyles();
  const [openCommonQuestion, setOpenCommonQuestion] = React.useState(false);
  const [openQ1, setOpenQ1] = React.useState(false);
  const [openQ2, setOpenQ2] = React.useState(false);
  const [openQ3, setOpenQ3] = React.useState(false);
  const [openQ4, setOpenQ4] = React.useState(false);
  const [openQ5, setOpenQ5] = React.useState(false);
  const [openQ6, setOpenQ6] = React.useState(false);

  const theme = useTheme();
  const matchesXS = useMediaQuery(theme.breakpoints.only("xs"));
  const matchesSM = useMediaQuery(theme.breakpoints.only("sm"));
  const matchesMD = useMediaQuery(theme.breakpoints.only("md"));

  const onClickCommonQuestion = () => {
    setOpenCommonQuestion(!openCommonQuestion);
  };

  const onClickQ1 = () => {
    setOpenQ1(!openQ1);
  };

  const onClickQ2 = () => {
    setOpenQ2(!openQ2);
  };

  const onClickQ3 = () => {
    setOpenQ3(!openQ3);
  };

  const onClickQ4 = () => {
    setOpenQ4(!openQ4);
  };

  const onClickQ5 = () => {
    setOpenQ5(!openQ5);
  };

  const onClickQ6 = () => {
    setOpenQ6(!openQ6);
  };

  const onClickHereViewDetails = () => {
    window.open("https://www.etiqa.com.sg/terms-conditions-renewal/");
  };

  const onClickOnlineAccount = () => {
    window.open(process.env.REACT_APP_LOGIN_BASE_URL);
  };

  const onClickGiroLink = () => {
    window.open(
      "https://www.etiqa.com.sg/wp-content/uploads/policy_documents_and_forms/others/Business-Reply-Envelope.pdf"
    );
  };

  const onClickGiroLinkV2 = () => {
    window.open(
      "https://www.etiqa.com.sg/wp-content/uploads/2024/11/GI_Giro_Application_Form.pdf"
    );
  };
  const onClickHere = () => {
    window.open(
      "https://www.etiqa.com.sg/online/quotation/hdb-fire-insurance"
    );
  };

  return (
    <div className={classes.root}>
      {window.innerWidth > 600 ? (
        <Grid container>
          <Grid item xs={12} sm={6} className={classes.leftContainer}>
            <Grid
              container
              direction={"column"}
              spacing={2}
              style={
                openCommonQuestion
                  ? { marginBottom: 50, marginTop: 20 }
                  : matchesXS
                    ? { marginBottom: 0, marginTop: 100 }
                    : { marginBottom: 0, marginTop: 20 }
              }
            >
              <Grid item>
                <CustomText design={classes.titleTextStyle}>
                  3 Easy Steps to Renew Quickly
                </CustomText>
              </Grid>

              <div style={{ color: '#FE541B', display: 'flex', flexDirection: 'row', justifyContent: 'center', alignItems: 'center', fontSize: '14px', fontWeight: '600' }}><img src={Image.redHint} style={{ marginRight: '0.5rem' }} />Not applicable for HDB Fire Insurance</div>

              <Grid item style={{ marginTop: 20 }}>
                <Grid
                  container
                  direction={matchesXS ? "column" : "row"}
                  justify={matchesXS ? "center" : "space-between"}
                  alignItems={"center"}
                  spacing={2}
                >
                  <Grid item xs={12} sm>
                    <div className={classes.connectorImageContainer}>
                      <img
                        src={Image.enterPolicyNoLogo}
                        className={classes.imageStepStyle}
                      />
                      <CustomText
                        design={classes.stepTextStyle}
                        style={matchesSM ? { marginTop: 10 } : { marginTop: 0 }}
                      >
                        Enter your Policy Number
                      </CustomText>
                    </div>
                  </Grid>
                  <Grid item xs={12} sm>
                    <div className={classes.connectorImageContainer}>
                      <img
                        src={
                          matchesXS
                            ? Image.connectorVerticalLogo
                            : Image.connectorLogo
                        }
                        className={classes.connectorImageStyle}
                      />
                    </div>
                  </Grid>
                  <Grid item xs={12} sm>
                    <div className={classes.connectorImageContainer}>
                      <img
                        src={Image.checkCoverageLogo}
                        className={classes.imageStepStyle}
                        style={
                          matchesMD ? { marginTop: 20 } : { marginBottom: 0 }
                        }
                      />
                      <CustomText design={classes.stepTextStyle}>
                        Check your coverage duration
                      </CustomText>
                    </div>
                  </Grid>
                  <Grid item xs={12} sm>
                    <div className={classes.connectorImageContainer}>
                      <img
                        src={
                          matchesXS
                            ? Image.connectorVerticalLogo
                            : Image.connectorLogo
                        }
                        className={classes.connectorImageStyle}
                      />
                    </div>
                  </Grid>
                  <Grid item xs={12} sm>
                    <div className={classes.connectorImageContainer}>
                      <img
                        src={Image.creditCardLogo}
                        className={classes.imageStepStyle}
                      />
                      <CustomText design={classes.stepTextStyle}>
                        Make payment via credit card
                      </CustomText>
                    </div>
                  </Grid>
                </Grid>
              </Grid>

              <Grid item xs={12} sm style={{ marginTop: 20 }}>
                <RowSection
                  title={"Common Questions"}
                  icon={
                    openCommonQuestion ? (
                      <RemoveRoundedIcon style={{ fill: "#2c3034" }} />
                    ) : (
                      <AddRoundedIcon style={{ fill: "#2c3034" }} />
                    )
                  }
                  onClickRowSection={onClickCommonQuestion}
                />
              </Grid>

              {openCommonQuestion ? (
                <Grid item xs={12} sm>
                  <Collapse
                    in={openCommonQuestion}
                    timeout="auto"
                    unmountOnExit
                    style={{ paddingLeft: 5, paddingRight: 5 }}
                  >
                    <CommonQuestions
                      openCommonQuestion={openCommonQuestion}
                      openQ1={openQ1}
                      onClickQ1={onClickQ1}
                      onClickHereViewDetails={onClickHereViewDetails}
                      onClickOnlineAccount={onClickOnlineAccount}
                      onClickGiroLink={onClickGiroLink}
                      onClickQ2={onClickQ2}
                      openQ2={openQ2}
                      openQ3={openQ3}
                      onClickQ3={onClickQ3}
                      openQ4={openQ4}
                      onClickQ4={onClickQ4}
                      openQ5={openQ5}
                      onClickQ5={onClickQ5}
                      openQ6={openQ6}
                      onClickQ6={onClickQ6}
                      onClickGiroLinkV2={onClickGiroLinkV2}
                      onClickHere={onClickHere}
                    />
                  </Collapse>
                </Grid>
              ) : (
                false
              )}

              <Grid
                item
                className={openCommonQuestion ? classes.TNCContainer : null}
              >
                <CustomText design={classes.TNCTextStyle} component="div">
                  Terms and Conditions apply.
                </CustomText>
              </Grid>

              <Grid item className={classes.helpContainer}>
                <Grid
                  container
                  direction={"column"}
                  justify={"center"}
                  alignItems={"center"}
                  spacing={3}
                >
                  <Grid item>
                    <CustomText design={classes.titleTextStyle}>
                      Need Help?
                    </CustomText>
                  </Grid>
                  <Grid item>
                    <img
                      src={Image.hLogo}
                      className={classes.customerCareImageStyle}
                      style={{ color: "#2C3034" }}
                    />
                    <img
                      src={Image.contactUsLogo}
                      className={classes.customerCareImageStyle}
                      style={{ color: "#2C3034" }}
                    />
                  </Grid>

                  <Grid item>
                    <CustomText design={classes.customerCareTextStyle}>
                      Customer Care & WhatsApp Service
                    </CustomText>
                    <CustomText design={classes.customerCareTextStyle}>
                      +65 6887 8777
                    </CustomText>
                  </Grid>
                </Grid>
              </Grid>
            </Grid>
          </Grid>

          {/*Right*/}
          <Grid
            item
            xs={12}
            sm={6}
            style={{
              height: height,
              justifyContent: window.innerWidth < 600 || maintainMsg ? false : "center",
              alignItems: maintainMsg ? "" : "center",
              display: "flex",
              flexDirection: "column",
            }}
          >
            <div>{maintenanceChild}</div>
            <Grid container direction={"column"} alignItems={"center"}>
              <Grid item>
                <div className={classes.childrenContainer}>{children}</div>
              </Grid>
            </Grid>
          </Grid>
        </Grid>
      ) : (
        <Grid container>

          <Grid
            item
            xs={12}
            sm={6}
            style={{
              height: height,
              justifyContent: window.innerWidth < 600 ? false : "center",
              alignItems: "center",
              display: "flex",
              flexDirection: "column",
              marginTop: '5rem'
            }}
          >
            <Grid container direction={"column"} alignItems={"center"}>
              <Grid item>
                <div className={classes.childrenContainer}>{children}</div>
              </Grid>
            </Grid>
          </Grid>

          <Grid item xs={12} sm={6} className={classes.leftContainer}>
            <Grid
              container
              direction={"column"}
              spacing={2}
              style={
                openCommonQuestion
                  ? { marginBottom: 50, marginTop: 20 }
                  : matchesXS
                    ? { marginBottom: 0, marginTop: 100 }
                    : { marginBottom: 0, marginTop: 20 }
              }
            >
              <Grid item>
                <CustomText design={classes.titleTextStyle}>
                  3 Easy Steps to Renew Quickly
                </CustomText>
              </Grid>

              <div style={{ color: '#FE541B', display: 'flex', flexDirection: 'row', justifyContent: 'center', alignItems: 'center', fontSize: '14px', fontWeight: '600' }}><img src={Image.redHint} style={{ marginRight: '0.5rem' }} />Not applicable for HDB Fire Insurance</div>

              <Grid item style={{ marginTop: 20 }}>
                <Grid
                  container
                  direction={matchesXS ? "column" : "row"}
                  justify={matchesXS ? "center" : "space-between"}
                  alignItems={"center"}
                  spacing={2}
                >
                  <Grid item xs={12} sm>
                    <div className={classes.connectorImageContainer}>
                      <img
                        src={Image.enterPolicyNoLogo}
                        className={classes.imageStepStyle}
                      />
                      <CustomText
                        design={classes.stepTextStyle}
                        style={matchesSM ? { marginTop: 10 } : { marginTop: 0 }}
                      >
                        Enter your Policy Number
                      </CustomText>
                    </div>
                  </Grid>
                  <Grid item xs={12} sm>
                    <div className={classes.connectorImageContainer}>
                      <img
                        src={
                          matchesXS
                            ? Image.connectorVerticalLogo
                            : Image.connectorLogo
                        }
                        className={classes.connectorImageStyle}
                      />
                    </div>
                  </Grid>
                  <Grid item xs={12} sm>
                    <div className={classes.connectorImageContainer}>
                      <img
                        src={Image.checkCoverageLogo}
                        className={classes.imageStepStyle}
                        style={
                          matchesMD ? { marginTop: 20 } : { marginBottom: 0 }
                        }
                      />
                      <CustomText design={classes.stepTextStyle}>
                        Check your coverage duration
                      </CustomText>
                    </div>
                  </Grid>
                  <Grid item xs={12} sm>
                    <div className={classes.connectorImageContainer}>
                      <img
                        src={
                          matchesXS
                            ? Image.connectorVerticalLogo
                            : Image.connectorLogo
                        }
                        className={classes.connectorImageStyle}
                      />
                    </div>
                  </Grid>
                  <Grid item xs={12} sm>
                    <div className={classes.connectorImageContainer}>
                      <img
                        src={Image.creditCardLogo}
                        className={classes.imageStepStyle}
                      />
                      <CustomText design={classes.stepTextStyle}>
                        Make payment via credit card
                      </CustomText>
                    </div>
                  </Grid>
                </Grid>
              </Grid>

              <Grid item xs={12} sm style={{ marginTop: 20 }}>
                <RowSection
                  title={"Common Questions"}
                  icon={
                    openCommonQuestion ? (
                      <RemoveRoundedIcon style={{ fill: "#2c3034" }} />
                    ) : (
                      <AddRoundedIcon style={{ fill: "#2c3034" }} />
                    )
                  }
                  onClickRowSection={onClickCommonQuestion}
                />
              </Grid>

              {openCommonQuestion ? (
                <Grid item xs={12} sm>
                  <Collapse
                    in={openCommonQuestion}
                    timeout="auto"
                    unmountOnExit
                    style={{ paddingLeft: 5, paddingRight: 5 }}
                  >
                    <CommonQuestions
                      openCommonQuestion={openCommonQuestion}
                      openQ1={openQ1}
                      onClickQ1={onClickQ1}
                      onClickHereViewDetails={onClickHereViewDetails}
                      onClickOnlineAccount={onClickOnlineAccount}
                      onClickGiroLink={onClickGiroLink}
                      onClickQ2={onClickQ2}
                      openQ2={openQ2}
                      openQ3={openQ3}
                      onClickQ3={onClickQ3}
                      openQ4={openQ4}
                      onClickQ4={onClickQ4}
                      openQ5={openQ5}
                      onClickQ5={onClickQ5}
                      openQ6={openQ6}
                      onClickQ6={onClickQ6}
                      onClickGiroLinkV2={onClickGiroLinkV2}
                      onClickHere={onClickHere}
                    />
                  </Collapse>
                </Grid>
              ) : (
                false
              )}

              <Grid
                item
                className={openCommonQuestion ? classes.TNCContainer : null}
              >
                <CustomText design={classes.TNCTextStyle} component="div">
                  Terms and Conditions apply.
                </CustomText>
              </Grid>

              <Grid item className={classes.helpContainer}>
                <Grid
                  container
                  direction={"column"}
                  justify={"center"}
                  alignItems={"center"}
                  spacing={3}
                >
                  <Grid item>
                    <CustomText design={classes.titleTextStyle}>
                      Need Help?
                    </CustomText>
                  </Grid>
                  <Grid item>
                    <img
                      src={Image.hLogo}
                      className={classes.customerCareImageStyle}
                      style={{ color: "white" }}
                    />
                    <img
                      src={Image.contactUsLogo}
                      className={classes.customerCareImageStyle}
                      style={{ color: "white" }}
                    />
                  </Grid>

                  <Grid item>
                    <CustomText design={classes.customerCareTextStyle}>
                      Customer Care & WhatsApp Service
                    </CustomText>
                    <CustomText design={classes.customerCareTextStyle}>
                      +65 6887 8777
                    </CustomText>
                  </Grid>
                </Grid>
              </Grid>
            </Grid>
          </Grid>
          {/*Right*/}

        </Grid>
      )}
    </div>
  );
};

export default CustomBoardRenewal;
